export const FirstRank = () => {
    return (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 19.2618L17.8198 22.7914C18.8856 23.4383 20.1898 22.4821 19.9094 21.2727L18.3667 14.6353L23.5134 10.1635C24.453 9.3479 23.9482 7.80105 22.7141 7.70261L15.9407 7.12606L13.2902 0.854283C12.8134 -0.284761 11.1866 -0.284761 10.7098 0.854283L8.05935 7.112L1.28591 7.68855C0.0518278 7.78699 -0.453025 9.33384 0.486562 10.1494L5.63325 14.6213L4.09065 21.2586C3.81017 22.468 5.11437 23.4242 6.18017 22.7774L12 19.2618Z"
                fill="#F1BF2E"
            />
            <text
                x="12"
                y="14"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="white"
                fontSize="10"
                fontWeight="bold"
                fontFamily="Arial, sans-serif"
            >
                1
            </text>
        </svg>
    );
};

export const SecondRank = () => {
    return (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 19.2618L17.8198 22.7914C18.8856 23.4383 20.1898 22.4821 19.9094 21.2727L18.3667 14.6353L23.5134 10.1635C24.453 9.3479 23.9482 7.80105 22.7141 7.70261L15.9407 7.12606L13.2902 0.854283C12.8134 -0.284761 11.1866 -0.284761 10.7098 0.854283L8.05935 7.112L1.28591 7.68855C0.0518278 7.78699 -0.453025 9.33384 0.486562 10.1494L5.63325 14.6213L4.09065 21.2586C3.81017 22.468 5.11437 23.4242 6.18017 22.7774L12 19.2618Z"
                fill="#79747E"
            />
            <text
                x="12"
                y="14"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="white"
                fontSize="10"
                fontWeight="bold"
                fontFamily="Arial, sans-serif"
            >
                2
            </text>
        </svg>
    );
};

export const ThirdRank = () => {
    return (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 19.2618L17.8198 22.7914C18.8856 23.4383 20.1898 22.4821 19.9094 21.2727L18.3667 14.6353L23.5134 10.1635C24.453 9.3479 23.9482 7.80105 22.7141 7.70261L15.9407 7.12606L13.2902 0.854283C12.8134 -0.284761 11.1866 -0.284761 10.7098 0.854283L8.05935 7.112L1.28591 7.68855C0.0518278 7.78699 -0.453025 9.33384 0.486562 10.1494L5.63325 14.6213L4.09065 21.2586C3.81017 22.468 5.11437 23.4242 6.18017 22.7774L12 19.2618Z"
                fill="#B04313"
            />
            <text
                x="12"
                y="14"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="white"
                fontSize="10"
                fontWeight="bold"
                fontFamily="Arial, sans-serif"
            >
                3
            </text>
        </svg>
    );
};
